'use strict';

import angular from 'angular';
import PatchService from './patch.service';

export default angular.module('storageApp.resource', [])
  .service('$patch', PatchService)
  .factory('Storage', function($http, socket, $resource, $patch, $rootScope){
    'ngInject';

    var products                = [];
    var analogs                 = [];
    var categories              = [];
    var characteristics         = [];
    var users                   = [];
    var modules                 = [];
    var barcodes                = {};
    var storages                = {};
    var movements               = [];
    var counters                = [];
    var categoryCharacteristics = [];

    var events                  = {};

    let Product        = $resource('/api/products/:id/:controller',                 {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Module         = $resource('/api/modules/:id/:controller',                  {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Analog         = $resource('/api/analogs/:id/:controller',                  {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Category       = $resource('/api/categories/:id/:controller',               {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Document       = $resource('/api/documents/:id/:controller',                {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Characteristic = $resource('/api/characteristics/:id/:controller',          {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Storage        = $resource('/api/storages/:id/:controller',                 {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Counter        = $resource('/api/counters/:id/:controller',                 {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let User           = $resource('/api/users/:id/:controller',                    {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Movement       = $resource('/api/movements/:id/:controller',                {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let Barcode        = $resource('/api/barcodes/:id/:controller/:productId',      {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});
    let CategoryChars  = $resource('/api/category-characteristics/:id/:controller', {id: '@_id'}, {update: { method: "PUT" }, patch: {method: 'PATCH'}});


    var saveItem = (Resource, item) => {
      return (() => {
        if(item._id){
          return $patch.save(Resource, item.toJSON ? item.toJSON() : item)
            .then((result) => result.$promise);
        } else {
          return (new Resource(item)).$save();
        }
      })();
    };

    var methods = {
      onUpdate: (event, cb) => {
        events[event] = cb;
      },

      getModuleByService: (service) => {
        return modules.filter(module => module.resourceName == service).shift();
      },

      load: () => {
        return Product.query().$promise
          .then(response => {
            products = response;
            socket.syncUpdates('product', products, (event, product) => (events.product || angular.noop)(product, event));
          })

          .then(() => Category.query().$promise)
          .then(response => {
            categories = response;
            socket.syncUpdates('category', categories, (event, category) => (events.category || angular.noop)(category, event));
          })

          .then(() => User.query().$promise)
          .then(response => {
            users = response;
            socket.syncUpdates('user', users);
          })

          .then(() => Module.query().$promise)
          .then((response) => {
            modules = response;
            socket.syncUpdates('module', modules);
          })

          .then(() => Characteristic.query().$promise)
          .then((response) => {
            characteristics = response;
            socket.syncUpdates('characteristic', characteristics, (event, characteristic) => (events.characteristic || angular.noop)(characteristic, event));
          })

          .then(() => Storage.query().$promise)
          .then((response) => {
            storages = response;
            socket.syncUpdates('storage', storages, (event, storage) => (events.storage || angular.noop)(storage, event));
          })
      },

      loadStorages: (productId) => {
        return Storage.query({
          productId: productId
        })
          .$promise
          .then(response => {
            // store data
            storages[productId] = response;
            
            socket.socket.on('storage:save', (item) => {
              if(item.productId != productId){
                return;
              }

              var oldItem = _.find(storages[productId], {_id: item._id});
              var index = storages[productId].indexOf(oldItem);
              var event = 'created';

              if(oldItem) {
                storages[productId].splice(index, 1, item);
                event = 'updated';
              } else {
                storages[productId].push(item);
              }
            });

            socket.socket.on('storage:remove', (item) => {
              if(item.productId != productId){
                return;
              }

              _.remove(storages[productId], {_id: item._id});
            });

            return storages[productId];
          });
      },

      loadFromApi: (name, Resource, arr, filter, key) => {
        return Resource.query(filter)
          .$promise
          .then(response => {
            var tmpArr, value;
            if(key){
              value = filter[key];
              arr[value] = arr[value] || [];
              // store data
              tmpArr = arr[value];
            } else {
              tmpArr = arr;
            }

            tmpArr = response;
            
            socket.socket.on('storage:save', (item) => {
              
              if(key && item[key] != value){
                return;
              }

              var oldItem = _.find(tmpArr, {_id: item._id});
              var index = tmpArr.indexOf(oldItem);
              var event = 'created';

              if(oldItem) {
                tmpArr.splice(index, 1, item);
                event = 'updated';
              } else {
                tmpArr.push(item);
              }

              (events[name] || angular.noop)(item, event)
            });

            socket.socket.on('storage:remove', (item) => {
              if(key && item[key] != value){
                return;
              }

              _.remove(tmpArr, {_id: item._id});
              (events[name] || angular.noop)(item, 'remove');
            });

            if(key){
              value = filter[key];
              arr[value] = arr[value] || [];
              // store data
              arr[value] = tmpArr;
            } else {
              arr = tmpArr;
            }

            return tmpArr;
          });
      },

      loadCategoryCharacteristics: (categoryId) => {
        return CategoryChars.query({
          categoryId: categoryId
        })
          .$promise
          .then(response => {
            // store data
            categoryCharacteristics[categoryId] = response;
            
            socket.socket.on('categoryCharacterstic:save', (item) => {
              if(item.categoryId != categoryId){
                return;
              }

              var oldItem = _.find(categoryCharacteristics[categoryId], {_id: item._id});
              var index = categoryCharacteristics[categoryId].indexOf(oldItem);
              var event = 'created';

              if(oldItem) {
                categoryCharacteristics[categoryId].splice(index, 1, item);
                event = 'updated';
              } else {
                categoryCharacteristics[categoryId].push(item);
              }
            });

            socket.socket.on('categoryCharacterstic:remove', (item) => {
              if(item.categoryId != categoryId){
                return;
              }

              _.remove(categoryCharacteristics[categoryId], {_id: item._id});
            });

            return categoryCharacteristics[categoryId];
          });
      },

      loadCounters: () => {
        return Counter.query()
          .$promise
          .then(response => {
            counters = response;
            socket.syncUpdates('counter', counters, (event, counter) => (events.counter || angular.noop)(counter, event));

            return counters;
          });
      },

      loadMovements: (filter) => {
        return Movement.query(filter)
          .$promise
          .then(response => {
            // store data
            movements = response;
            
            socket.socket.on('movement:save', (item) => {
              //if(item.productId != productId){
              //  return;
              //}

              var oldItem = _.find(movements, {_id: item._id});
              var index = movements.indexOf(oldItem);
              var event = 'created';

              if(oldItem) {
                movements.splice(index, 1, item);
                event = 'updated';
              } else {
                movements.push(item);
              }
            });

            socket.socket.on('movement:remove', (item) => {
              //if(item.productId != productId){
              //  return;
              //}

              _.remove(movements, {_id: item._id});
            });

            return movements;
          });
      },

      loadBarcodes: (productId) => {
        return Barcode.query({
          productId: productId
        })
          .$promise
          .then(response => {
            // store data
            barcodes[productId] = response;
            
            socket.socket.on('barcode:save', (item) => {
              if(item.productId != productId){
                return;
              }

              var oldItem = _.find(barcodes[productId], {_id: item._id});
              var index = barcodes[productId].indexOf(oldItem);
              var event = 'created';

              if(oldItem) {
                barcodes[productId].splice(index, 1, item);
                event = 'updated';
              } else {
                barcodes[productId].push(item);
              }
            });

            socket.socket.on('barcode:remove', (item) => {
              if(item.productId != productId){
                return;
              }

              _.remove(barcodes[productId], {_id: item._id});
            });

            return barcodes[productId];
          });
      },

      loadDocuments: (filter) => {
        return Document.query(filter);
      },

      addItem: (item, arr) => {
        var found = false;
        arr.forEach((x,i) => {
          if(x._id == item._id) {
            arr[i] = item;
            found = true;
          }
        });

        if( ! found){
          arr.push(item);
        }
      },

      addCategory: (category) => {
        return methods.addItem(category, categories);
      },

      addProduct: (product) => {
        return methods.addItem(product, products);
      },

      addCharacteristic: (characteristic) => {
        return methods.addItem(characteristic, characteristics);
      },

      addStorage: (storage) => {
        return methods.addItem(storage, storages);
      },

      addCounter: (counter) => {
        return methods.addItem(counter, counters);
      },

      saveCategoryCharacteristic: (row) => {
        return saveItem(CategoryChars, row);
      },

      saveCategory: (row) => {
        return saveItem(Category, row)
          .then((category) => {
            methods.addCategory(category);
            $rootScope.$broadcast('storage.save.category', category);
          });
      },

      saveProduct: (row) => {
        return saveItem(Product, row)
          .then((product) => {
            methods.addProduct(product);
            $rootScope.$broadcast('storage.save.product', product);
          });
      },

      saveCharacteristic: (row) => {
        return saveItem(Characteristic, row)
          .then((characteristic) => {
            methods.addCharacteristic(characteristic);
            $rootScope.$broadcast('storage.save.characteristic', characteristic);
          });
      },

      saveCounter: (row) => {
        return saveItem(Counter, row)
          .then((counter) => {
            methods.addCounter(counter);
            $rootScope.$broadcast('storage.save.counter', counter);
          });
      },

      saveBarcode: (row) => {
        return saveItem(Barcode, row);
      },

      saveMovement: (row) => {
        return saveItem(Movement, row);
      },

      saveStorage: (row) => {
        return saveItem(Storage, row)
          .then((storage) => {
            methods.addStorage(storage);
            $rootScope.$broadcast('storage.save.storage', storage);
          });
      },

      saveDocument: (row) => {
        return saveItem(Document, row);
      },

      saveModule: (row) => {
        return saveItem(Module, row);
      },

      saveAnalog: (row) => {
        return saveItem(Analog, row);
      },

      removeStorage: (row) => {
        return (new Storage(row))
          .$remove();
      },

      removeBarcode: (row) => {
        return (new Barcode(row))
          .$remove();
      },

      removeAnalog: (row) => {
        return (new Analog(row))
          .$remove();
      },

      removeCategoryCharacteristic: (row) => {
        return (new CategoryChars(row))
          .$remove();
      },

      removeCounter: (row) => {
        return (new Counter(row))
          .$remove();
      },

      getProducts: () => {
        return products;
      },

      getCharacteristics: () => {
        return characteristics;
      },

      getStorages: () => {
        return storages;
      },

      getCategories: () => {
        return categories;
      },

      getBarcodes: () => {
        return barcodes;
      },

      getUsers: () => {
        return users;
      },

      getModules: () => {
        return modules;
      },

      getCounters: () => {
        return counters;
      },

      unbind: () => {
        socket.unsyncUpdates('product');
        socket.unsyncUpdates('category');
        socket.unsyncUpdates('barcode');
        socket.unsyncUpdates('module');
        socket.unsyncUpdates('characteristic');
        socket.unsyncUpdates('storage');
        socket.unsyncUpdates('counter');
      }
    };

    return methods;
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/storage/storage.component.js